$('.js-slider-b2c').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
          dots: false,
        arrows: false,
        speed: 1000,
        fade: true,
        asNavFor: '.js-navSlider-b2c'
      });
      $('.js-navSlider-b2c').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.js-slider-b2c',
        dots: false,
          arrows: false,
        infinite: true,
          autoplay: true,
         centerMode: false,
        autoplaySpeed: 5000,
        focusOnSelect: true
      });


//header active class

      document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector(".header");
    const heeader_wrapper = document.querySelector(".header-holder");
    window.addEventListener("scroll", function () {
        if (window.scrollY > 100) {
            header.classList.add("is-scrolled");
            heeader_wrapper.classList.add("ps-active");
        } else {
            header.classList.remove("is-scrolled");
            heeader_wrapper.classList.remove("ps-active");
        }
    });
});

// Collection page image grid slider
function initProductSliders() {
  $('.product-slider').each(function () {
    if (!$(this).hasClass('slick-initialized')) {
      $(this).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        speed: 400,
        adaptiveHeight: false,
        //accessibility: false,
        prevArrow:'<button class="slick-prev custom-arrow" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">  <path d="M15 18l-6-6 6-6"/></svg></button>',
        nextArrow:'<button class="slick-next custom-arrow" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button>',
        //prevArrow:'<button class="slick-prev custom-arrow" aria-label="Previous">&#10094;</button>',
        //nextArrow:'<button class="slick-next custom-arrow" aria-label="Next">&#10095;</button>',
        responsive: [          
          {
            breakpoint: 767,
            settings: {
              arrows: false
            }
          }
        ]
        //prevArrow:
        //  '<button type="button" class="slick-prev"><svg aria-hidden="true" focusable="false" role="presentation" enable-background="new -19 23 66 16" viewBox="-19 23 66 16" xmlns="http://www.w3.org/2000/svg"><path d="m-19 29.6h64v2.9h-64z"></path><path d="m47 31-2-2-6-6-2 2 5.9 6-5.9 6 2 2 6-6z"></path></svg></button>',
       // nextArrow:
        //  '<button type="button" class="slick-next"><svg aria-hidden="true" focusable="false" role="presentation" enable-background="new -19 23 66 16" viewBox="-19 23 66 16" xmlns="http://www.w3.org/2000/svg"><path d="m-19 29.6h64v2.9h-64z"></path><path d="m47 31-2-2-6-6-2 2 5.9 6-5.9 6 2 2 6-6z"></path></svg></button>' 
      });
    }
  });
}
// Keyboard Navigation
$(document).on('keydown', function(e) {
  if (e.key === 'ArrowLeft') {
    $('.product-slider').slick('slickPrev');
  }

  if (e.key === 'ArrowRight') {
    $('.product-slider').slick('slickNext');
  }
});
$(document).ready(function () {
  initProductSliders();
});
$(document).ready(function () {

$(document).on('click', '.product-slider, .slick-prev, .slick-next', function(e){
    //e.preventDefault();
    e.stopPropagation();
});

$(document).on('mousedown touchstart', '.product-slider', function(e){
    e.stopPropagation();
});
$(document).on('mouseleave', '.product-item', function(e){
    var $slider = $(this).find('.product-slider');

    if ($slider.hasClass('slick-initialized')) {
        $slider.slick('slickGoTo', 0, true);
    }
});
});


//Product page slider number showing


 $('.product-gallery__items').on('init reInit afterChange', function(event, slick, currentSlide) {

    var i = (currentSlide ? currentSlide : 0) + 1;

    $('.product-gallery__index').text(i);
    $('.product-gallery__total').text(slick.slideCount);

});

//product page slider 
$('.product-gallery__items').slick({
    infinite: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1, 
    adaptiveHeight: true,  
    speed: 400,
    prevArrow:'<button class="slick-prev product-gallery__prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">  <path d="M15 18l-6-6 6-6"/></svg></button>',
    nextArrow:'<button class="slick-next product-gallery__next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button>',
    responsive: [          
      {
        breakpoint: 767,
        settings: {
          arrows: false
        }
      }
    ]
});


// Load more 
  document.addEventListener("click", async function(e){

    if(!e.target.matches("#LoadMoreBtn")) return;

    const btn = e.target;

    console.log("Current URL:", btn.dataset.url);

    btn.disabled = true;
    btn.innerHTML = "Loading...";

    const response = await fetch(btn.dataset.url);
    const html = await response.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    // Desktop products
    const currentDesktop = document.querySelector(".desktop-grid");
    const newDesktop = doc.querySelector(".desktop-grid");

    if(currentDesktop && newDesktop){
        currentDesktop.insertAdjacentHTML("beforeend", newDesktop.innerHTML);
        setTimeout(() => {
    document.querySelectorAll(".custom-product-grid img.lazy").forEach(function(img) {
        img.classList.add("lazyloaded");
        img.classList.remove("lazy");
    });
}, 100);
    }
    initProductSliders();

    // Mobile products
    const currentMobile = document.querySelector(".mobile-grid");
    const newMobile = doc.querySelector(".mobile-grid");

    if(currentMobile && newMobile){
        currentMobile.insertAdjacentHTML("beforeend", newMobile.innerHTML);
        setTimeout(() => {
    document.querySelectorAll(".custom-product-grid img.lazy").forEach(function(img) {
        img.classList.add("lazyloaded");
        img.classList.remove("lazy");
    });
}, 100);
    }
    initProductSliders();

    // Update button
    const nextBtn = doc.querySelector("#LoadMoreBtn");
    console.log("Next URL:", nextBtn?.dataset.url);
    if(nextBtn){
        btn.dataset.url = nextBtn.dataset.url;
        btn.disabled = false;
        btn.innerHTML = "View More Objects";
    }else{
        btn.parentElement.remove();
    }
});


//request a popup

  $(document).on('click', '.request_btn', function(){
    var dataTitle = $(this).data('title');
    $(document).find('.product_title_input').val(dataTitle);
    $(document).find('.modal-popup').addClass('active');
    $(document).find('.body_overlay').addClass('active');
  });
  $(document).on('click', '.modal-popup .cross_btn, .body_overlay', function(){
    $(document).find('.modal-popup').removeClass('active');
    $(document).find('.body_overlay').removeClass('active');
    $(document).find('.body_overlay').hide();
  }); 


//bespoke-popup js
  $(document).on('click', '.bespoke-popup-btn', function(){
    var dataTitle = $(this).data('title');
    $(document).find('.product_title_input').val(dataTitle);
    $(document).find('.bespoke-popup .modal-popup').addClass('active');
    $(document).find('.body_overlay').addClass('active');
  });
  $(document).on('click', '.modal-popup .cross_btn, .body_overlay', function(){
    $(document).find('.modal-popup').removeClass('active');
    $(document).find('.body_overlay').removeClass('active');
    $(document).find('.body_overlay').hide();
  });